module.exports = __webpack_public_path__ + "images/category_lp/furniture/store_images/2_da7df2ae5995cc0366d527a82f554f90.png";